import { Routes, Route } from "react-router-dom";
import LoginPage from "../pages/authPages/Login";
import RegisterPage from "../pages/authPages/Register";
import SSOCallback from "../pages/authPages/SSOCallback";

import ProtectedRoute from "./ProtectedRoute";
import ApproverRoute from "./ApproverRoute";
import {
  ADMINS,
  ADMINS_AND_MANAGERS,
  BOOKING_APPROVERS,
  FINANCE_STAFF_WITH_ADMINS,
  LEADERSHIP_DASHBOARD_ACCESS,
  PAYMENT_REPORT_VIEWERS,
  REFUND_REQUESTERS,
  REPORT_VIEWERS,
  ROLES,
  SALE_CREATORS,
} from "../constants/roles";
import { ToastContainer } from "react-toastify";

import ForgotPassword from "../pages/authPages/ForgotPassword";
import ResetPassword from "../pages/authPages/ResetPassword";
import ProfilePage from "../pages/ProfilePage";
import OtpWrapper from "../pages/authPages/smsServices/OtpWrapper";
import ResetOtpPassword from "../pages/authPages/smsServices/ResetOtpPassword";
import PendingUsers from "../pages/admin/PendingUsers";
import PropertyCommissionPage from "../pages/admin/PropertyCommissionPage";
import CompanyRolePage from "../pages/CompanyRolePage";
import NotFoundPage from "../pages/errorpages/NotFoundPage";
import PropertyList from "../pages/propertiespage/PropertyList";
import PropertyDetails from "../pages/propertiespage/PropertyDetails";
import PaymentBookingPage from "../pages/PropertyBooking/PaymentBookingPage";
import UnitDetailsBooking from "../pages/PropertyBooking/UnitDetailsBooking";
import ManagerBookingDashboard from "../pages/PropertyBooking/ManagerBookingDashboard";
import PropertyAvailableBookingList from "../pages/PropertyBooking/PropertyAvailableBookingList";
import PropertyUnitsBookingList from "../pages/PropertyBooking/PropertyUnitsBookingList";
import PropertyBookedList from "../pages/PropertyBooking/PropertyBookedList";
import BookingDetails from "../pages/PropertyBooking/BookingDetails";
import UnitDetailsPage from "../pages/PropertyBooking/UnitDetailsPage";
import OverdueBookingList from "../pages/accountsPages/OverdueBookingList";
import BookingList from "../pages/accountsPages/BookingList";
import InstallmentSearchPage from "../pages/accountsPages/InstallmentSearchPage";
import PaymentSuccessPage from "../pages/PropertyBooking/PaymentSuccessPage";
import ReportsDashboard from "../pages/reports/ReportsDashboard";
import SoldUnitReport from "../pages/reports/SoldUnitReport";
import SalesByRoleReport from "../pages/reports/SalesByRoleReport";
import PendingPaymentReport from "../pages/reports/PendingPaymentReport";
import OverduePaymentsReport from "../pages/reports/OverduePaymentsReport";
import TopSellingPropertiesReport from "../pages/reports/TopSellingPropertiesReport";
import InventoryReport from "../pages/reports/InventoryReport";
import PriceTrendsReport from "../pages/reports/PriceTrendsReport";
import TimeToSellReport from "../pages/reports/TimeToSellReport";
import PropertyWiseReport from "../pages/reports/PropertyWiseReport";
import Landing from "../pages/Home/Landing";
import MainLayout from "../pages/layoutpage/MainLayout";

import Dashboard from "../pages/admin/DashBoard";
import SoldUnitByMonth from "../pages/reports/SoldUnitByMonth";
import SalesByAgent from "../pages/reports/SalesByAgent";
import DocumentManagement from "../pages/DocumentManagement/DocumentManagement";
import SecurityModule from "../pages/SecurityManagement/SecurityMoudle";
import SystemSettings from "../pages/SystemSettings/SystemSettings ";
import VendorManagement from "../pages/VendorManagement/VendorManagement";
import PropertyDetailsModern from "../pages/PropertyDetailsNew/PropertyDetailsNew";
import HomeLayout from "../pages/HomeLayout/HomeLayout";
import AvailableProperties from "../pages/AvailableProperties/AvailtableProperties";
import ContactUs from "../pages/ContactUs/ContactUs";
import AboutUs from "../pages/AboutUs/AboutUs";
import RoleSelection from "../pages/RoleSelection/RoleSelection";
import RoleRequestHistory from "../pages/RoleRequestHistory/RoleRequestHistory";
import ApproverDashboard from "../pages/ApproverDashboard/ApproverDashboard";
import LeadershipDashboard from "../pages/LeadershipDashboard/LeadershipDashboard";
import { legacyLeadershipRedirects } from "./legacyLeadershipRedirects";
import MarketingOfficer from "../pages/MarketingOfficerDashboard/MarketingOfficer";

// Agent Sales
import MakeSalePage from "../pages/Sales/MakeSalePage";
import InvoiceView from "../pages/Sales/InvoiceView";
import FinanceDirector from "../pages/FinanceDirectorDashboard/FinanceDirector";
import IconicGallery from "../pages/IconicGallery/IconicGallery";
import GeneralUser from "../pages/GeneralUserDashboard/GeneralUser";
import MyPayments from "../pages/MyPayments/MyPayments";
import RefundRequestsPage from "../pages/refunds/RefundRequestsPage";
import UnityCommissionsPage from "../pages/admin/UnityCommissionsPage";
import ManageRolesPage from "../pages/admin/ManageRolesPage";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "../pages/TermsAndConditions/TermsAndConditions";
import SiteMap from "../pages/SiteMap/SiteMap";
import OurStory from "../pages/AboutUs/OurStory";
import MissionVision from "../pages/AboutUs/MissionVision";
import OurManagementBoard from "../pages/AboutUs/OurManagmentBoard";
import Testimonials from "../pages/AboutUs/Testimonials";
import WhyChooseUs from "../pages/AboutUs/WhyChoseUs";
import IconicBlog from "../pages/IconicBlog/IconicBlog";
import IconicBlogDetails from "../pages/IconicBlog/IconicBlogDetails";
import IconicFAQ from "../pages/IconicFAQ/IconicFAQ";



const RouteAll = () => {
  // Safe JSON.parse to handle null values
  const getUserFromStorage = () => {
    try {
      const userData = localStorage.getItem("user");
      return userData ? JSON.parse(userData) : null;
    } catch (error) {
      console.error("Error parsing user data from localStorage:", error);
      return null;
    }
  };
  const user = getUserFromStorage();

  const onLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.reload();
  };
  return (
    <>
      <ToastContainer position="bottom-right" autoClose={3000} style={{ zIndex: "9999" }} />
      <Routes>
        {/* ---------- PUBLIC ROUTES ------------ */}
        <Route element={<HomeLayout />}>
          <Route path="/" element={<Landing />} />
          <Route path="/greenland/properties" element={<AvailableProperties />} />
          <Route path="/greenland/properties/:id" element={<PropertyDetailsModern />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/about/our-story" element={<OurStory />} />
          <Route path="/about/mission-vision" element={<MissionVision />} />
          <Route path="/about/our-managment-board" element={<OurManagementBoard></OurManagementBoard>} />
          <Route path="/about/testimonial" element={<Testimonials></Testimonials>
          } />
          <Route path="/about/why-choose-us" element={<WhyChooseUs></WhyChooseUs>} />


          <Route path="/privacy-policy" element={<PrivacyPolicy></PrivacyPolicy>} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions></TermsAndConditions>} />
          <Route path="/site-map" element={<SiteMap></SiteMap>} />


          <Route path="/gallery" element={<IconicGallery />} />
          <Route path="/blogs" element={<IconicBlog />} />
          <Route path="/blogs/:slug" element={<IconicBlogDetails />} />
          <Route path="/faq" element={<IconicFAQ />} />

        </Route>

        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/sso-callback" element={<SSOCallback />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/otp" element={<OtpWrapper />} />
        <Route path="/reset-otp-password" element={<ResetOtpPassword />} />

        {/* ---------- MAIN LAYOUT WRAPPER ---------- */}
        <Route
          element={
            <ProtectedRoute>
              <MainLayout
                user={user}
                onLogout={onLogout}
                sidebarCollapsed={false}
              />
            </ProtectedRoute>
          }
        >
          <Route path="/profile" element={<ProfilePage />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={REPORT_VIEWERS}>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-roles"
            element={
              <ProtectedRoute allowedRoles={ADMINS}>
                <CompanyRolePage />
              </ProtectedRoute>
            }
          />
          {/*  Manage Roles */}
          <Route
            path="/manage-roles"
            element={
              <ProtectedRoute allowedRoles={ADMINS}>
                <ManageRolesPage />
              </ProtectedRoute>
            }
          />
          {/* security Module */}
          <Route
            path="/security-management"
            element={
              <ProtectedRoute allowedRoles={ADMINS}>
                <SecurityModule />
              </ProtectedRoute>
            }
          />
          {/* System Settings Module */}
          <Route
            path="/system-settings"
            element={
              <ProtectedRoute allowedRoles={ADMINS}>
                <SystemSettings />
              </ProtectedRoute>
            }
          />
          {/* Vendor Module */}
          <Route
            path="/vendor-management"
            element={
              <ProtectedRoute allowedRoles={ADMINS}>
                <VendorManagement />
              </ProtectedRoute>
            }
          />


          <Route
            path="/property-commissions"
            element={
              <ProtectedRoute allowedRoles={ADMINS}>
                <PropertyCommissionPage />
              </ProtectedRoute>
            }
          />

          {/* sale commissions sent to Iconic Unity: status and Retry */}
          <Route
            path="/unity-commissions"
            element={
              <ProtectedRoute allowedRoles={ADMINS}>
                <UnityCommissionsPage />
              </ProtectedRoute>
            }
          />


          <Route
            path="/pending-users"
            element={
              <ApproverRoute>
                <PendingUsers />
              </ApproverRoute>
            }
          />

          {/* properties */}
          <Route path="/properties" element={<PropertyList />} />
          <Route path="/properties/:id" element={<PropertyDetails />} />

          {/* property booking */}
          <Route
            path="/properties_available"
            element={<PropertyAvailableBookingList />}
          />
          <Route
            path="/properties_available/:id"
            element={<PropertyUnitsBookingList />}
          />
          <Route path="/units/:id" element={<UnitDetailsPage />} />
          <Route
            path="/properties_available_booking/:bookingId"
            element={<UnitDetailsBooking />}
          />

          <Route path="/properties_booked" element={<PropertyBookedList />} />
          <Route path="/properties_booked/:id" element={<BookingDetails />} />

          {/* Agent Sales */}
          <Route path="/dashboard/make-sale" element={
            <ProtectedRoute allowedRoles={SALE_CREATORS}>
              <MakeSalePage />
            </ProtectedRoute>
          } />
          <Route path="/dashboard/invoice/:id" element={
             <ProtectedRoute>
                <InvoiceView />
             </ProtectedRoute>
          } />

          {/* =========================================== */}

          {/* One shared dashboard for Chairman, MD, Executive Director and Investor; the API decides the cards. */}
          <Route
            path="/leadership"
            element={
              <ProtectedRoute allowedRoles={LEADERSHIP_DASHBOARD_ACCESS}>
                <LeadershipDashboard />
              </ProtectedRoute>
            }
          />
          {/* Old per-role dashboard URLs still work: they land on /leadership. */}
          {legacyLeadershipRedirects()}
          <Route
            path="/marketing"
            element={
              <ProtectedRoute allowedRoles={[ROLES.MARKETING_OFFICER]}>
                <MarketingOfficer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance-director"
            element={
              <ProtectedRoute allowedRoles={[ROLES.FINANCE_DIRECTOR]}>
                <FinanceDirector />
              </ProtectedRoute>
            }
          />
          <Route
            path="/general-user"
            element={
              <ProtectedRoute>
                <GeneralUser />
              </ProtectedRoute>
            }
          />
          {/* My Payments: any signed-in user, data is scoped to their own bookings by the API */}
          <Route
            path="/my-payments"
            element={
              <ProtectedRoute>
                <MyPayments />
              </ProtectedRoute>
            }
          />

          {/* =========================================== */}

          {/* Role Selection  */}
          <Route path="/role_selection" element={<RoleSelection />} />
          <Route path="/role-requests" element={<RoleRequestHistory />} />
          <Route
            path="/approver-dashboard"
            element={
              <ApproverRoute>
                <ApproverDashboard />
              </ApproverRoute>
            }
          />

          <Route path="/payment/:bookingId" element={<PaymentBookingPage />} />
          <Route
            path="/payment-success/:bookingId"
            element={<PaymentSuccessPage />}
          />

          {/* account */}
          <Route
            path="/late-fees"
            element={
              <ProtectedRoute allowedRoles={FINANCE_STAFF_WITH_ADMINS}>
                <OverdueBookingList />
              </ProtectedRoute>
            }
          />

          {/* manager dashboard */}
          <Route
            path="/manager/bookings"
            element={
              <ProtectedRoute allowedRoles={BOOKING_APPROVERS}>
                <ManagerBookingDashboard />
              </ProtectedRoute>
            }
          />

          {/* installments */}
          <Route
            path="/installments"
            element={
              <ProtectedRoute allowedRoles={FINANCE_STAFF_WITH_ADMINS}>
                <BookingList />
              </ProtectedRoute>
            }
          />

          <Route
            path="/installments-search"
            element={
              <ProtectedRoute allowedRoles={FINANCE_STAFF_WITH_ADMINS}>
                <InstallmentSearchPage />
              </ProtectedRoute>
            }
          />

          {/* refund requests: Finance Director / Admin file them, a Superadmin decides */}
          <Route
            path="/refund-requests"
            element={
              <ProtectedRoute allowedRoles={REFUND_REQUESTERS}>
                <RefundRequestsPage />
              </ProtectedRoute>
            }
          />

          {/* reports */}
          <Route
            path="/reports"
            element={
              <ProtectedRoute allowedRoles={PAYMENT_REPORT_VIEWERS}>
                <ReportsDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/sold-units-month-wise"
            element={
              <ProtectedRoute allowedRoles={REPORT_VIEWERS}>
                <SoldUnitByMonth />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/sold-units"
            element={
              <ProtectedRoute allowedRoles={REPORT_VIEWERS}>
                <SoldUnitReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/sales-by-role"
            element={
              <ProtectedRoute allowedRoles={REPORT_VIEWERS}>
                <SalesByRoleReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/pending-payments"
            element={
              <ProtectedRoute allowedRoles={PAYMENT_REPORT_VIEWERS}>
                <PendingPaymentReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/overdue-payments"
            element={
              <ProtectedRoute allowedRoles={PAYMENT_REPORT_VIEWERS}>
                <OverduePaymentsReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/top-selling-properties"
            element={
              <ProtectedRoute allowedRoles={REPORT_VIEWERS}>
                <TopSellingPropertiesReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/inventory"
            element={
              <ProtectedRoute allowedRoles={REPORT_VIEWERS}>
                <InventoryReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/agent-wise"
            element={
              <ProtectedRoute allowedRoles={REPORT_VIEWERS}>
                <SalesByAgent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/price-trends"
            element={
              <ProtectedRoute allowedRoles={REPORT_VIEWERS}>
                <PriceTrendsReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/time-to-sell"
            element={
              <ProtectedRoute allowedRoles={REPORT_VIEWERS}>
                <TimeToSellReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/property-wise"
            element={
              <ProtectedRoute allowedRoles={REPORT_VIEWERS}>
                <PropertyWiseReport />
              </ProtectedRoute>
            }
          />
          {/* Document Management */}
          <Route
            path="/documentManagement"
            element={
              <ProtectedRoute allowedRoles={ADMINS_AND_MANAGERS}>
                <DocumentManagement />
              </ProtectedRoute>
            }
          />
        </Route>

        {/* ---------- 404 ---------- */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

export default RouteAll;
